import React from "react";
import { observer, useLocalStore } from "mobx-react";
import { Grid } from "@mui/material";
import { EOCAsyncSelect } from "../input/EOCAsyncSelect";
import { useMsal } from "@azure/msal-react";
import apiCall from "../../scripts/apiCall";

export default observer(
  ({
    title,
    value,
    required,
    updatefunc,
    multi = false,
    isCreatable = false,
  }) => {
    const { instance, accounts } = useMsal();
    const getData = (input) =>
      new Promise((resolve) => {
        let fetchOptions = {
          method: "POST",
          credentials: "same-origin",
          body: JSON.stringify({
            sb: "zapi_local_interf_sb",
            proj: "zapi_local_interf_sd",
            funct: "locationHelp",
            //parameters: `$format=json`,
            parameters:
              `$filter=spras eq 'EN'` +
              (input !== "" ? ` and contains(descr40 ,'${input}')` : ""),
            version: "0001",
          }),
        };
        var sys = window.localStorage.getItem("QUOTEsys");
        let url = `SAPOData${sys}/V4`;

        return apiCall(
          url,
          fetchOptions,
          (json) => {
            console.log(json);

            resolve(
              json.value.map((result) => ({
                Id: result.descr40,
                Name: result.descr40,
                value: result.descr40,
                label: result.descr40,
              }))
            );
          },
          instance,
          accounts
        );
      });

    const lstore = useLocalStore(() => ({
      onChange(newVal, actionMeta) {
        if (newVal !== null) {
          if (multi) {
            if (isCreatable && actionMeta.action === "create-option")
              newVal.forEach((element) => {
                if (element.__isNew__) {
                  element.Name = element.label;
                  element.Id = "0";
                }
              });
            updatefunc(newVal);
          } else {
            if (newVal.__isNew__) {
              newVal.Name = newVal.label;
              newVal.Id = "0";
            }
            updatefunc(newVal);
          }
        } else {
          updatefunc(null);
        }
      },
    }));

    return (
      <Grid container spacing={0} direction="column">
        <Grid item xs>
          <label>
            {title}
            {required && " *"}
          </label>
        </Grid>
        <Grid item xs>
          <EOCAsyncSelect
            cy={title}
            isMulti={multi}
            loadOptions={getData}
            value={value}
            updateF={lstore.onChange}
            clearAble={isCreatable}
            isCreatable={isCreatable}
            defaultOptions
          />
        </Grid>
      </Grid>
    );
  }
);
